export const TagsAndAttributesMenuLabelMap = {
  "crm-tags": "CRM Tags",
  "chat-tags": "Conversation Tags",
  "chat-properties": "Custom Conversation Properties",
  "crm-properties": "Custom CRM Properties",
};
